import { useEffect, useState } from 'react';
import { launcherPreferencesService } from '../services/launcherPreferences';

export function useLauncherLocale(): string {
    const [locale, setLocale] = useState(() => launcherPreferencesService.getLocale());

    useEffect(() => launcherPreferencesService.subscribeLocale(setLocale), []);

    return locale;
}

export function useLauncherGameLocale(): string {
    const [gameLocale, setGameLocale] = useState(() =>
        launcherPreferencesService.getGameLocale()
    );

    useEffect(() => launcherPreferencesService.subscribeGameLocale(setGameLocale), []);

    return gameLocale;
}
